import React from "react";
import PropTypes from "prop-types";
import { InputField } from "../../../components/Form/FormComponents";
import { formatDeliveryType } from "../utils";
import { BsPatchCheck } from "react-icons/bs";
import { IoWarningOutline } from "react-icons/io5";
import { getCurrentDate } from "../../lease/utils";

const DeliveryInfo = ({ requestData, handleChange, handleNumberChange, data, isEditable }) => {
	const isDeliveryFeeEditable = () => {
		if (isEditable && requestData?.deliveryInfo?.deliveryFeeStatus !== "paid") {
			return true;
		}
		if (isEditable && requestData?.deliveryInfo?.deliveryFeeStatus === "paid") {
			return false;
		} else {
			return false;
		}
	};

	const status = () => {
		if (isEditable) {
			return null;
		}
		if (requestData?.deliveryInfo?.deliveryFee) {
			if (requestData?.deliveryInfo?.deliveryFeeStatus === "paid") {
				return true;
			} else {
				return false;
			}
		} else {
			return null;
		}
	};

	const formattedDate = getCurrentDate();

	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>DELIVERY TYPE</label>
				<InputField
					name='deliveryType'
					value={formatDeliveryType(requestData?.deliveryType || "Door Delivery")}
				/>
			</div>
			{requestData?.deliveryType === "pick-up" ? (
				<div className='form-group'>
					<label>PICKUP ADDRESS</label>
					<InputField
						name='pickupAddress'
						isEditable={isEditable}
						value={data?.pickupAddress}
						handleChange={handleChange}
					/>
				</div>
			) : (
				<>
					<div className='form-group'>
						<label>DELIVERY ADDRESS</label>
						<InputField
							name='createdAt'
							value={requestData?.deliveryAddress || requestData?.user?.homeAddress}
						/>
					</div>
					<div className='form-group' style={{ position: "relative" }}>
						<label>DELIVERY FEE</label>
						<InputField
							isEditable={isDeliveryFeeEditable()}
							handleChange={handleNumberChange}
							name='deliveryFee'
							value={data?.deliveryFee}
						/>
						<span className='deliveryFeeStatus'>
							{status() === null ? (
								""
							) : status() ? (
								<BsPatchCheck size={24} color='green' />
							) : (
								<IoWarningOutline size={24} color='gold' />
							)}
						</span>
					</div>
					<div className='form-group'>
						<label>ESTIMATED DELIVERY DATE</label>
						<InputField
							isEditable={isEditable}
							type='date'
							handleChange={handleChange}
							name='deliveryDate'
							min={formattedDate}
							value={data?.deliveryDate}
						/>
					</div>
					<div className='form-group'>
						<label>DELIVERY AGENT</label>
						<InputField
							isEditable={isEditable}
							handleChange={handleChange}
							name='agentName'
							value={data?.agentName}
						/>
					</div>
					<div className='form-group'>
						<label>AGENT NUMBER</label>
						<InputField
							isEditable={isEditable}
							handleChange={handleNumberChange}
							maxLength={11}
							type='tel'
							name='agentNumber'
							value={data?.agentNumber}
						/>
					</div>
				</>
			)}
		</div>
	);
};

export default DeliveryInfo;

DeliveryInfo.propTypes = {
	requestData: PropTypes.object,
	data: PropTypes.object,
	handleChange: PropTypes.func,
	handleNumberChange: PropTypes.func,
	isEditable: PropTypes.bool,
};
